import { Button } from '@bm-js/atlascloud-ui'
import Input from './Input'
import { ChangeEvent, encodeSweUrlComponent } from '@bm-js/atlascloud-shared'

type Props = {
  formData: {
    password: string
    customerName: string
  }
  handleChange: (e: ChangeEvent) => void
  submit: (e: React.FormEvent<HTMLFormElement>) => void
  loading: boolean
  errors: {
    password?: string
    customerName?: string
  }
}

const GetStartedBasicInfo = ({
  formData,
  handleChange,
  submit,
  loading,
  errors,
}: Props) => {
  return (
    <div>
      <form onSubmit={submit} className='flex flex-col'>
        <Input
          disabled={loading}
          autoFocus
          label='Välj ditt lösenord'
          desc='Minst 8 tecken, både små och stora bokstäver och minst en siffra.'
          type='password'
          value={formData.password}
          error={errors.password}
          onChange={handleChange}
          name='password'
          required
        />
        <Input
          disabled={loading}
          label='Föreningens/företagets namn'
          type='text'
          value={formData.customerName}
          error={errors.customerName}
          onChange={handleChange}
          name='customerName'
          required
        />
        {formData.customerName && (
          <p className='mb-6 text-center leading-5'>
            Hemsidans address blir
            <br />
            <span className='font-bold'>
              {encodeSweUrlComponent(formData.customerName)}.atlascloud.se
            </span>
          </p>
        )}
        <Button className='self-center' disabled={loading} type='submit'>
          {loading ? 'Skapar...' : 'Skapa hemsida'}
        </Button>
      </form>
    </div>
  )
}

export default GetStartedBasicInfo
